import { render, staticRenderFns } from "./UkrTreasuresPayPalButtonsFilter.vue?vue&type=template&id=703e74fd&scoped=true"
import script from "./UkrTreasuresPayPalButtonsFilter.vue?vue&type=script&lang=js"
export * from "./UkrTreasuresPayPalButtonsFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "703e74fd",
  null
  
)

export default component.exports